import React, { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import { SvgIconProps } from "@mui/material/SvgIcon";
import SlackIcon from "./SlackIcon";

import { useStore } from "csi/state/hooks";


const SlackIndicator: FunctionComponent<SvgIconProps> = observer((props) => {
	const { routerStore } = useStore();
	const { locationNode } = routerStore;

	return <SlackIcon mono={!locationNode.SlackChannels.length} {...props} />;
});

export default SlackIndicator;
